import React from 'react';
import { useTranslation } from 'react-i18next';
import './EventStatusBadge.css';

export type EventStatus = 'scheduled' | 'changed' | 'cancelled';

interface EventStatusBadgeProps {
  status?: EventStatus | null;
  /** Tighter type for dense surfaces (calendar chips, day lists). */
  compact?: boolean;
}

// Events created before migration 0056 arrive without the field; they are
// scheduled, which is also the column default.
const EventStatusBadge: React.FC<EventStatusBadgeProps> = ({ status, compact = false }) => {
  const { t } = useTranslation();
  const value: EventStatus = status ?? 'scheduled';

  return (
    <span
      className={`event-status-badge event-status-badge--${value}${compact ? ' event-status-badge--compact' : ''}`}
    >
      {t(`events.status.${value}`)}
    </span>
  );
};

export default EventStatusBadge;
